/* Time-of-day gradient + accent for the hero card */

// 6 time bands (24-hour, local time)
//  0-5   night
//  5-8   sunrise
//  8-11  morning
// 11-15  midday
// 15-19  sunset
// 19-24  twilight -> night
export const getTimeOfDay = (date = new Date()) => {
  const h = date.getHours();
  if (h >= 5 && h < 8) return 'sunrise';
  if (h >= 8 && h < 11) return 'morning';
  if (h >= 11 && h < 15) return 'midday';
  if (h >= 15 && h < 19) return 'sunset';
  if (h >= 19 && h < 22) return 'twilight';
  return 'night';
};

export const TIME_OF_DAY_THEMES = {
  sunrise: {
    label: 'Sunrise',
    overlay:
      'linear-gradient(to top, rgba(120, 53, 15, 0.85) 0%, rgba(217, 119, 6, 0.45) 35%, rgba(254, 215, 170, 0.05) 75%, transparent 100%)',
    tag: 'text-amber-200',
    glow: 'rgba(251, 191, 36, 0.18)',
    accent: '#fbbf24',         // amber-400 — soft gold
    accentSoft: 'rgba(251, 191, 36, 0.35)',
    iconText: '#fde68a',       // amber-200
  },
  morning: {
    label: 'Morning',
    overlay:
      'linear-gradient(to top, rgba(15, 23, 42, 0.78) 0%, rgba(56, 189, 248, 0.25) 45%, transparent 100%)',
    tag: 'text-sky-200',
    glow: 'rgba(125, 211, 252, 0.15)',
    accent: '#38bdf8',
    accentSoft: 'rgba(56, 189, 248, 0.30)',
    iconText: '#bae6fd',
  },
  midday: {
    label: 'Midday',
    overlay:
      'linear-gradient(to top, rgba(15, 23, 42, 0.70) 0%, rgba(15, 23, 42, 0.25) 50%, transparent 100%)',
    tag: 'text-emerald-200',
    glow: 'rgba(110, 231, 183, 0.12)',
    accent: '#34d399',
    accentSoft: 'rgba(52, 211, 153, 0.25)',
    iconText: '#a7f3d0',
  },
  sunset: {
    label: 'Sunset',
    overlay:
      'linear-gradient(to top, rgba(76, 5, 25, 0.88) 0%, rgba(244, 63, 94, 0.45) 30%, rgba(251, 146, 60, 0.20) 65%, transparent 100%)',
    tag: 'text-rose-200',
    glow: 'rgba(251, 113, 133, 0.20)',
    accent: '#fb7185',         // rose-400
    accentSoft: 'rgba(251, 113, 133, 0.30)',
    iconText: '#fecdd3',
  },
  twilight: {
    label: 'Twilight',
    overlay:
      'linear-gradient(to top, rgba(30, 27, 75, 0.88) 0%, rgba(76, 29, 149, 0.45) 40%, rgba(192, 132, 252, 0.15) 75%, transparent 100%)',
    tag: 'text-violet-200',
    glow: 'rgba(167, 139, 250, 0.20)',
    accent: '#a78bfa',         // violet-400
    accentSoft: 'rgba(167, 139, 250, 0.30)',
    iconText: '#ddd6fe',
  },
  night: {
    label: 'Night',
    overlay:
      'linear-gradient(to top, rgba(8, 8, 23, 0.95) 0%, rgba(30, 27, 75, 0.55) 45%, rgba(67, 56, 202, 0.10) 80%, transparent 100%)',
    tag: 'text-indigo-200',
    glow: 'rgba(99, 102, 241, 0.20)',
    accent: '#818cf8',         // indigo-400
    accentSoft: 'rgba(129, 140, 248, 0.30)',
    iconText: '#c7d2fe',
  },
};

export const getTimeTheme = (date = new Date()) => {
  const tod = getTimeOfDay(date);
  return { tod, ...TIME_OF_DAY_THEMES[tod] };
};
